import { defineField } from 'sanity'

import { ActiveAnnouncementBanners } from '../components'

export default defineField({
  type: 'document',
  title: 'Announcement Banners',
  name: 'siteBanners',
  description: `The announcement banner is shown above the site's header and can contain links and other calls to action.

Add, remove and reorder entries in the list below to specify which banners may be shown to users. The site will show the first banner in the list with visibility rules that fit the current user's session.`,
  fields: [
    {
      title: 'Active banner configurations',
      name: 'banners',
      type: 'array',
      of: [{ type: 'reference', to: [{ type: 'announcementBanner' }] }],
      components: {
        field: ActiveAnnouncementBanners
      }
    }
  ]
})
